import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";
import Link from "@material-ui/core/Link";
import Modal from "@material-ui/core/Modal";
import Typography from "@material-ui/core/Typography";
import { FileDownloadTwoTone } from "@material-ui/icons";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useModalClose } from "../../hooks";
import { actionReset } from "../../store/invoice/create/actions";
import ButtonSave from "./ButtonSave";
import FieldDateOfReceipt from "./FieldDateOfReceipt";
import FieldFile from "./FieldFile";
import FieldNumber from "./FieldNumber";
import FieldRow from "./FieldRow";
import FieldVendor from "./FieldVendor";
import {EnumPackageType, PageInvoiceCreateFC} from "./types";
import FieldPackageType from "./FieldPackageType";
import FieldQuantityPackages from "./FieldQuantityPackages";
import FieldWarehouse from "./FieldWarehouse";
import {Backdrop, CircularProgress} from "@material-ui/core";
import ButtonSaveProducts from "./ButtonSaveProducts";

const PageInvoiceCreate: PageInvoiceCreateFC = ({ onClose }) => {
  const dispatch = useDispatch();
  const [saving, setSaving] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const href = new URL(window.location.href).pathname.split('/').slice(0, 3).join('/');
  const { changed, invoice, active_warehouses } = useSelector(
    ({
      invoice: {
        create: { changed, invoice },
      },
       currentUserInfo: { data: info},
    }) => ({ changed, invoice, active_warehouses: info && info.active_warehouses })
  );

  const handlerClose = useModalClose({
    navigateUrl: href,
    status: !saving,
    statusMessage: "Идет сохранение накладной",
    confirmationMessage: "Закрыть форму без сохранения?",
  });

  useEffect(() => {
    return () => {
      dispatch(actionReset());
    }
  }, []);

  useEffect(() => {
    if (active_warehouses && active_warehouses.length > 1) {
      if (!!invoice.vendor && !!invoice.dateOfReceipt && !!invoice.number && !!invoice.warehouse && !!invoice.packageType) {
        if (invoice.packageType !== EnumPackageType.PALLET || (invoice.packageType === EnumPackageType.PALLET && !!invoice.quantityPackages)) {
          setDisabled(false);
        } else {
          setDisabled(true);
        }
      }
    } else {
      if (!!invoice.vendor && !!invoice.dateOfReceipt && !!invoice.number && !!invoice.packageType) {
        if (invoice.packageType !== EnumPackageType.PALLET || (invoice.packageType === EnumPackageType.PALLET && !!invoice.quantityPackages)) {
          setDisabled(false);
        } else {
          setDisabled(true);
        }
      }
    }
  }, [invoice]);

  return (
    <Modal open onClose={handlerClose(changed)}>
      <Dialog open onClose={handlerClose(changed)} maxWidth={"sm"} fullWidth>
        <DialogTitle>
          <Typography variant={"h4"}>Создание накладной</Typography>
          <Typography variant={"subtitle2"}>
            Заполните форму для загрузки накладной
          </Typography>
        </DialogTitle>
        <DialogContent dividers>
          <Grid container>
            <FieldRow label="Поставщик:" required>
              <FieldVendor saving={saving} />
            </FieldRow>
            <FieldRow label="Номер накладной:" required>
              <FieldNumber saving={saving} />
            </FieldRow>
            {active_warehouses && active_warehouses.length > 1 ?
                <FieldRow label="Склад:" required>
                  <FieldWarehouse saving={saving} />
                </FieldRow>
                :
                null
            }
            <FieldRow label="Дата прихода:" required>
              <FieldDateOfReceipt saving={saving} />
            </FieldRow>
            <FieldRow label="В каком виде придет товар?" required>
              <FieldPackageType saving={saving} />
            </FieldRow>
            {invoice.packageType === EnumPackageType.PALLET || invoice.packageType === EnumPackageType.BOX ?
                <FieldRow label="Количество мест:" required={invoice.packageType === EnumPackageType.PALLET}>
                  <FieldQuantityPackages saving={saving} />
                </FieldRow>
                :
                null
            }
            {href === '/invoice/queue' &&
                <FieldRow
                    label="Файл накладной:"
                    // required
                    appendLabel={
                      <Button
                          LinkComponent={Link}
                          target={"_blank"}
                          href={"https://app.yunu.ru/invoice/template/download"}
                          color={"info"}
                          size={"small"}
                          sx={{position: "relative", right: "-6px"}}
                          startIcon={
                            <FileDownloadTwoTone color={"info"} fontSize={"small"}/>
                          }
                      >
                        {"Скачать шаблон"}
                      </Button>
                    }
                >
                  <FieldFile saving={saving}/>
                </FieldRow>
            }
          </Grid>
        </DialogContent>
        <DialogActions>
          {href === '/invoice/queue' ?
              <ButtonSave
                  setSaving={setSaving}
                  saving={disabled}
                  onSave={handlerClose(false)}
              />
              :
              <ButtonSaveProducts
                  setSaving={setSaving}
                  saving={disabled}
                  onSave={handlerClose(false)}
              />
          }
          <Button
            disabled={saving}
            color={"warning"}
            variant={"outlined"}
            onClick={onClose ? onClose : handlerClose(false)}
          >
            {"Отменить"}
          </Button>
        </DialogActions>
        {saving ?
            <div>
              <Backdrop
                  sx={{color: '#fff', zIndex: 999}}
                  open={saving}
              >
                <CircularProgress color="inherit"/>
              </Backdrop>
            </div>
            :
            null}
      </Dialog>
    </Modal>
  );
};

export default PageInvoiceCreate;
